module.exports = __webpack_public_path__ + "media/images/no_logo-b702e8ba.jpeg";